import { Container } from 'react-bootstrap'
import '../About/index.css'

const Index = () => {
  return (
    <div className='About-background'>
      <Container>
        <h1>Contacto</h1>
        <p>in.temporal.corto@gmail.com</p>
        <p>+58 (424-1340110)</p>
        <p>Cristina Betancourt - Directora de Producción</p>
      </Container>
    </div>
  )
}

export default Index